import { z } from 'zod';
import { isoUtcDateTimeSchema } from './date-time-schema';

export const viewSnapshotScheduleSchema = z.object({
  itemId: z.number().int(),
  expectedStartDateTime: isoUtcDateTimeSchema.nullable(),
  expectedFinishDateTime: isoUtcDateTimeSchema.nullable(),
  latestFinishDateTime: isoUtcDateTimeSchema.nullable(),
});

export type ViewSnapshotScheduleDTO = z.infer<typeof viewSnapshotScheduleSchema>;
